export const emptyRole = {
  id: null,
  version: null,
  name: '',
  description: '',
  permissionIds: [],
};

export const resolveApiError = (err, fallback) => {
  const payload = err?.response?.data;
  if (typeof payload === 'string') {
    return payload;
  }
  if (payload?.message) {
    return payload.message;
  }
  return fallback;
};

export const mapRoleToState = (role) => ({
  id: role?.id ?? null,
  version: role?.version ?? null,
  name: role?.name ?? '',
  description: role?.description ?? '',
  permissionIds: Array.isArray(role?.permissionIds) ? [...role.permissionIds] : [],
});
